import { type InputProps, Select, TextInput } from "@mantine/core";
import { useEffect, useMemo } from "react";
import { useController, useFormContext } from "react-hook-form";

import { type ITankPlan } from "../../components/pages/Settings/YachtSetUp/TankPlans/tankPlans.model";
import { useGetApi } from "../../hooks";

interface Props extends InputProps {
  id: string;
  type: "msfbA" | "msfbB" | "ballast" | "orb";
  tanktype?: string;
  value:
    | {
        key?: string;
        value?: string | { key: string };
        data?: { tankid: string; tankName: string };
      }
    | string;
}
const TankSelect = ({ type, id, value, tanktype }: Props) => {
  const { control, setValue } = useFormContext();

  const {
    field: { value: tankValue },
  } = useController({
    name: id,
    defaultValue: value,
    control,
  });

  const { data, isLoading, refetch } = useGetApi<{ list: ITankPlan[] }>({
    request: "get-tanks",
    body: { params: { [type]: true } },
    fetchOnInit: false,
  });

  useEffect(() => {
    if (type) {
      const apiType = type === "ballast" ? "bwl" : type;
      const params: any = {};
      if (apiType === "orb" && tanktype) {
        params.orbtype = tanktype;
      } else {
        params[apiType] = true;
      }
      void refetch({ params });
    }
  }, [type, tanktype]);

  const parsedTanks = useMemo(() => {
    const parsed =
      data?.list?.map((tank: any) => ({
        label: tank.name,
        value: tank.tankid,
      })) ?? [];
    if (
      value &&
      typeof value === "object" &&
      !parsed.some(tank => tank.value === value.key)
    ) {
      parsed.push({ label: value.value, value: value.key });
    }
    return parsed;
  }, [data]);

  const handleSelectChange = (value: string) => {
    setValue(id, {
      key: value,
      value: parsedTanks.find(tank => tank.value === value)?.label ?? value,
    });
  };

  return parsedTanks && parsedTanks.length > 0 ? (
    <Select
      value={tankValue?.key ?? ""}
      onChange={handleSelectChange}
      data={parsedTanks}
      required={false}
      placeholder="Select Tank"
      dropdownPosition="top"
      withinPortal={true}
      zIndex={1000}
    />
  ) : (
    <TextInput
      value={tankValue?.value ?? ""}
      placeholder="No Tanks Available"
      onChange={e => handleSelectChange(e.currentTarget.value)}
    />
  );
};
export default TankSelect;
